import ConstructionStageList from '../../slices/construction_management/construction_stage/ConstructionStageList'
import ConstructionStageDetails from '../../slices/construction_management/construction_stage/ConstructionStageDetails'
import ConstructionList from '../../slices/construction_management/construction/ConstructionList'
import ConstructionDetails from '../../slices/construction_management/construction/ConstructionDetails'
import AvailableConstructionPhases from '../../slices/construction_management/construction/AvailableConstructionPhases'
import ConstructionDailyLogList from '../../slices/construction_management/construction_daily_log/ConstructionDailyLogList'
import ConstructionDailyLogDetails from '../../slices/construction_management/construction_daily_log/ConstructionDailyLogDetails'

const constructionManagementReducer = {
    constructionStageList: ConstructionStageList,
    constructionStageDetails: ConstructionStageDetails,
    constructionList: ConstructionList,
    constructionDetails: ConstructionDetails,
    availableConstructionPhases: AvailableConstructionPhases,
    constructionDailyLogList: ConstructionDailyLogList,
    constructionDailyLogDetails: ConstructionDailyLogDetails,
};

export default constructionManagementReducer;
